/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { fetchGraphQl } from '@/account/api';
import { handleNetworkError } from '@/account/lib/network-error';
import { GET_CUSTOMER_ORDERS_LIST } from './graphql/getOrderHistoryList.graphql';
import { OrderHistoryListResponse } from '@/account/types';
import { transformOrderHistoryList } from '@/account/data/transforms';
import { OrderHistoryModel } from '@/account/data/models';

const SORT_DIRECTION = { sort_direction: 'DESC', sort_field: 'CREATED_AT' };

export const getOrderHistoryList = async (
  pageSize: number,
  selectOrdersDate: string,
  currentPage: number
): Promise<OrderHistoryModel | null> => {
  const filterOrderDate = !selectOrdersDate.includes('viewAll')
    ? {
        order_date: JSON.parse(selectOrdersDate),
      }
    : {};

  return await fetchGraphQl(GET_CUSTOMER_ORDERS_LIST, {
    method: 'GET',
    cache: 'no-cache',
    variables: {
      pageSize,
      currentPage,
      filter: filterOrderDate,
      sort: SORT_DIRECTION,
    },
  })
    .then((response: OrderHistoryListResponse) => {
      return transformOrderHistoryList(response);
    })
    .catch(handleNetworkError);
};
